// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 3px 5px;
}

.content {
  flex: 1;
  max-width: calc(100% - 120px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.actions {
  width: 120px;
}

.text {
  display: block;
  color: #272625;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  font-family: Roboto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.region {
  font-size: 0.875rem;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 3px;
}

.btn {
  height: 40px;
  min-width: 0 !important;
  width: 40px;
}
.btn .MuiSvgIcon-root {
  font-size: 1.2rem;
}
.btn-hide {
  display: none !important;
}

.date {
  display: block;
  margin-top: 3px;
  text-align: right;
  font-family: Roboto;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./res/stylesheets/assessmentListRenderer.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,OAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,QAAA;AACJ;;AACA;EACI,YAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AADI;EACI,iBAAA;AAGR;AADI;EACI,wBAAA;AAGR;;AACA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAEJ","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    box-sizing: border-box;\n    padding: 3px 5px;\n}\n\n.content {\n    flex: 1;\n    max-width: calc(100% - 120px);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n}\n\n.actions {\n    width: 120px;\n}\n\n.text {\n    display: block;\n    color: #272625;\n    font-weight: 400;\n    font-size: 0.75rem;\n    line-height: 1.66;\n    font-family: Roboto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.region {\n    font-size: 0.875rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 3px;\n}\n.btn {\n    height: 40px;\n    min-width: 0 !important;\n    width: 40px;\n    .MuiSvgIcon-root {\n        font-size: 1.2rem;\n    }\n    &-hide {\n        display: none !important;\n    }\n}\n\n.date {\n    display: block;\n    margin-top: 3px;\n    text-align: right;\n    font-family: Roboto;\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
